import { useState } from 'react';

export default function SupportModal() {
  const [showModal, setShowModal] = useState(true);

  return (
    showModal && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
        <div className="bg-white p-6 rounded-lg shadow-xl max-w-sm relative text-center space-y-4">
          {/* Close Button */}
          <button
            className="absolute top-3 right-3 text-gray-600 hover:text-gray-900 text-xl"
            onClick={() => setShowModal(false)}
          >
            ✖
          </button>

          {/* Modal Content */}
          <img
            src="/create-your-valentine.png"
            alt="Premium Features Preview"
            className="w-full rounded-lg"
          />
          <p className="text-gray-800 font-medium">
            This website is currently inactive to conserve cloud resources.
          </p>
          <p className="text-gray-600 text-sm">
            If you'd like to create a valentine, you can either visit the
            premium version or request access directly.
          </p>

          <div className="flex flex-col gap-3">
            <a
              href="https://create-your-valentine.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-pink-600 text-white px-6 py-2 rounded-md hover:bg-pink-700 transition"
            >
              Visit Premium Site
            </a>

            <a
              href={`mailto:markbriankiunga@gmail.com?subject=Request%20to%20Create%20a%20Valentine&body=Hi%20Mark%2C%0D%0A%0D%0AI%20would%20like%20access%20to%20Create%20Your%20Valentine.%0D%0A%0D%0AFull%20Name%3A%20%5BEnter%20Your%20Name%5D%0D%0AEmail%3A%20%5BEnter%20Your%20Email%5D%0D%0A%0D%0AThanks!`}
              className="bg-gray-800 text-white px-6 py-2 rounded-md hover:bg-gray-900 transition"
            >
              Request Access via Email
            </a>
          </div>
        </div>
      </div>
    )
  );
}
